import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

// export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
// export const LOGIN_URL = `${API_URL}/login`
// export const REGISTER_URL = `${API_URL}/register`
// export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verifyToken`
export const SESSION_URL = `${API_URL}/session`
export const LOGOUT_URL = `${API_URL}/logout`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot-password`
export const UPDATE_PASSWORD_URL = `${API_URL}/reset-password`
export const VALIDATE_RESET_TOKEN = `${API_URL}/reset-password-validate`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  }, {skipAuthRefresh: true} as any)
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  }, {skipAuthRefresh: true} as any)
}

export function requestPassword(email: string) {
  return axios.post(REQUEST_PASSWORD_URL, {email, origin: 'portal'}, {skipAuthRefresh: true} as any)
}

export function updatePass(token: string, password: string, confirmation: string) {
  return axios.post(UPDATE_PASSWORD_URL, {token, password, password_confirmation: confirmation}, {skipAuthRefresh: true} as any)
}

export function validateResetToken(token: string) {
  return axios.get(VALIDATE_RESET_TOKEN, {params: {token}, skipAuthRefresh: true} as any)
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}

export function getCurrentUser() {
  return axios.get<UserModel>(SESSION_URL, {withCredentials: true})
}

export function revokeSession() {
  return axios.post(LOGOUT_URL, {}, {skipAuthRefresh: true, withCredentials: true} as any)
}
